import { render } from "./FlushCache.vue?vue&type=template&id=330cf0d6&scoped=true"
import script from "./FlushCache.vue?vue&type=script&lang=js"
export * from "./FlushCache.vue?vue&type=script&lang=js"

import "./FlushCache.vue?vue&type=style&index=0&id=330cf0d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330cf0d6"]])

export default __exports__